import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { AlertCircle, Clock, FileText, CheckCircle2 } from 'lucide-react';

export const AdminDashboardSection = ({ stats, auditTrail }) => {
  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold text-slate-900">Dashboard</h1>
      
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card className="p-4 bg-red-50 border-red-200">
          <div className="flex items-center gap-3">
            <AlertCircle className="h-8 w-8 text-red-600" />
            <div>
              <p className="text-2xl font-bold text-red-600">{stats.overdueInputs}</p>
              <p className="text-sm text-red-600">Overdue Inputs</p>
            </div>
          </div>
        </Card>
        <Card className="p-4 bg-amber-50 border-amber-200">
          <div className="flex items-center gap-3">
            <Clock className="h-8 w-8 text-amber-600" />
            <div>
              <p className="text-2xl font-bold text-amber-600">{stats.pendingInputs}</p>
              <p className="text-sm text-amber-600">Pending Inputs</p>
            </div>
          </div>
        </Card>
        <Card className="p-4 bg-blue-50 border-blue-200">
          <div className="flex items-center gap-3">
            <FileText className="h-8 w-8 text-blue-600" />
            <div>
              <p className="text-2xl font-bold text-blue-600">{stats.awaitingApproval}</p>
              <p className="text-sm text-blue-600">Awaiting Approval</p>
            </div>
          </div>
        </Card>
        <Card className="p-4 bg-green-50 border-green-200">
          <div className="flex items-center gap-3">
            <CheckCircle2 className="h-8 w-8 text-green-600" />
            <div>
              <p className="text-2xl font-bold text-green-600">{stats.completed}</p>
              <p className="text-sm text-green-600">Completed</p>
            </div>
          </div>
        </Card>
      </div>

      {/* Recent Activity */}
      <Card className="p-6">
        <h2 className="text-lg font-semibold mb-4">Recent Client Activity</h2>
        {auditTrail.length === 0 ? (
          <p className="text-slate-500 text-center py-8">No recent activity</p>
        ) : (
          <div className="space-y-3">
            {auditTrail.map((event) => (
              <div key={event.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                <div className="flex items-center gap-3">
                  <Badge variant="outline" className="capitalize">
                    {event.eventType.replace('-', ' ')}
                  </Badge>
                  <span className="text-sm">
                    <span className="font-medium">{event.actor?.name}</span>
                    {' '}{event.eventType === 'submission' && 'submitted input'}
                    {event.eventType === 'approval' && 'approved deliverable'}
                    {event.eventType === 'revision-request' && 'requested revision'}
                    {event.eventType === 'comment' && 'added comment'}
                  </span>
                </div>
                <span className="text-xs text-slate-500">
                  {new Date(event.timestamp).toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
};
